export default "__VITE_ASSET__D64G4rwe__"